import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {VideosHelp} from '../../../model/strapi/videos-help/videos-help';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
    selector: 'app-videos-help',
    templateUrl: './videos-help.component.html',
    styleUrls: ['../../../../styles/standard-elements.scss', '../../../pages/help/help.component.scss'],
    standalone: false
})
export class VideosHelpComponent {

  videosHelps$: Observable<VideosHelp[]> = this.strapiService.getVideosHelp();

  constructor(private readonly strapiService: StrapiService, private readonly sanitizer: DomSanitizer) {}

  getSafeVideoUrl(videoId: string): SafeResourceUrl {
    const url = `https://player.vimeo.com/video/${videoId}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
